export default __webpack_public_path__ + "static/media/placeholder_dummy2016-weinhandel01-mobile-de.e5d0fbe5.png";